function Syria({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_2259)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M16 0C9.12061 0 3.25593 4.342 0.995239 10.4348H31.0049C28.7442 4.342 22.8795 0 16 0Z" fill="#D80027"/>
  <path d="M16 31.9993C22.8795 31.9993 28.7442 27.6573 31.0049 21.5645H0.995239C3.25593 27.6573 9.12061 31.9993 16 31.9993Z" fill="black"/>
  <path d="M9.56008 12.1738L10.4234 14.8308H13.2173L10.957 16.4732L11.8204 19.1303L9.56008 17.4881L7.29977 19.1303L8.16314 16.4732L5.90283 14.8308H8.69677L9.56008 12.1738Z" fill="#6DA544"/>
  <path d="M22.4398 12.1738L23.3032 14.8308H26.0972L23.8368 16.4732L24.7002 19.1303L22.4398 17.4881L20.1795 19.1303L21.0429 16.4732L18.7826 14.8308H21.5765L22.4398 12.1738Z" fill="#6DA544"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Syria;
